import type { FaireProductEntity } from "../../entity_types/product";

export const p_swafvepeah: FaireProductEntity = {
  token: "p_swafvepeah",
  type: "product",
  name: "A Year in the Garden Little Wall Calendar",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/a57ef56e6cbf501a606402fa748ded1ffee1bf51193937d5f8421643a9dcb32c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/80f1931771bdeef11731d02ae018ac5fdc70b8a709ed6cdf3e9b75a6bae36cea.jpeg",
    "https://cdn.faire.com/fastly/1ffa030fbb7f6a5c4ee440ebcd04f221d07629793574f4da94a32905edd8a11d.jpeg",
    "https://cdn.faire.com/fastly/50e8739d8b5f19e80f0508d1db1406faf7a52949db0e345ce89e05cfa60e0f5b.jpeg",
    "https://cdn.faire.com/fastly/bd67ba0595bd0f8a3b94de4bb708a58332967a2ae17c049603cfb6c3c8f967e9.jpeg",
  ],
  priceDollars: 13,
  description:
    "It's normal, we tell ourselves, to occasionally forget what month it is. Or year :) So we made this wall-hanging beauty for easy reference. Spend a year by the sea, with each month offering a gorgeous, salty-air painting to make your home or office feel that sunwashed bliss of the coast. Wait a sec... it's MAY?!!\n\n6\" x 9\"",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:34.478Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
